module.exports = __webpack_public_path__ + "img/2_david_d.3ede1f82.png";